var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6023 6.16333V7.44111C16.0376 7.88912 17.0834 9.18844 17.0834 10.7403V14.8544C17.0834 16.7756 15.4906 18.3333 13.5269 18.3333H6.47402C4.50948 18.3333 2.91669 16.7756 2.91669 14.8544V10.7403C2.91669 9.18844 3.96331 7.88912 5.39776 7.44111V6.16333C5.40623 3.67898 7.46391 1.66666 9.98732 1.66666C12.5446 1.66666 14.6023 3.67898 14.6023 6.16333ZM10.0043 3.11586C11.7232 3.11586 13.1204 4.48225 13.1204 6.16333V7.26141H6.87963V6.14677C6.8881 4.47397 8.28529 3.11586 10.0043 3.11586ZM10.741 13.7124C10.741 14.1182 10.4107 14.4412 9.99579 14.4412C9.58933 14.4412 9.25909 14.1182 9.25909 13.7124V11.874C9.25909 11.4765 9.58933 11.1536 9.99579 11.1536C10.4107 11.1536 10.741 11.4765 10.741 11.874V13.7124Z",
    fill: "#0577FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cc36d46b0c380677fd97040cd6e58902.svg";
export { ForwardRef as ReactComponent };